export function addToGlobalThisRet(property, propertyName) {
    if (!globalThis.ret) {
        globalThis.ret = {};
    }
    globalThis.ret[propertyName] = property;
}
